export default "__VITE_ASSET__gMOTqwfV__"